import { useState, useRef, useEffect } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

export const loadedImages = new Set();

const LazyImage = ({ src, alt, className, style, onClick }) => {
  const [loaded, setLoaded] = useState(loadedImages.has(src));
  const imgRef = useRef(null);

  useEffect(() => {
    if (imgRef.current && imgRef.current.complete) {
      if (!loaded) {
        setLoaded(true);
        loadedImages.add(src);
      }
    }
  }, [src, loaded]);

  const handleLoad = () => {
    setLoaded(true);
    loadedImages.add(src);
  };

  return (
    <div style={{ width: "100%", height: "100%", position: "relative" }}>
      {!loaded && <Skeleton width="100%" height="100%" />}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        onLoad={handleLoad}
        style={{
          width: "100%",
          height: "100%",
          // If loaded, show normally. If not, hide with opacity but keep in DOM as block
          // to ensure browser prioritizes loading. Position absolute prevents layout issues while loading.
          display: "block",
          opacity: loaded ? 1 : 0,
          position: loaded ? "static" : "absolute",
          top: 0,
          left: 0,
          ...style,
        }}
        className={className}
        onClick={onClick}
      />
    </div>
  );
};

export default LazyImage;
